/**
 * Bulk Buy / Multi-Buy Savings selector.
 *
 * Selecting a quantity tier writes straight into the theme's own native
 * quantity <input> (the same one the Quantity stepper uses) and fires a real
 * 'change' event, so Dawn's existing QuantityInput validation and the normal
 * Add to Cart form submission both pick it up exactly as if the shopper had
 * typed the number in themselves. Nothing here talks to the cart directly,
 * and no price shown is invented — the totals are computed from the live
 * product price using the discount percentages set in the theme editor,
 * which must match the automatic discounts configured in Shopify Admin.
 */
document.querySelectorAll('[data-bulk-buy-selector]').forEach((selector) => {
  const quantityInputId = selector.dataset.quantityInputId;
  const quantityInput = quantityInputId ? document.getElementById(quantityInputId) : null;

  if (!quantityInput) return;

  const options = selector.querySelectorAll('[data-bulk-buy-option]');

  const setSelected = (option) => {
    options.forEach((opt) => opt.classList.toggle('is-selected', opt === option));
  };

  options.forEach((option) => {
    const radio = option.querySelector('.bulk-buy-option__radio');
    const qty = parseInt(option.dataset.qty, 10);

    option.addEventListener('click', () => {
      if (!qty) return;

      radio.checked = true;
      setSelected(option);

      quantityInput.value = qty;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
